// N-Genius Payment Gateway for Margarethes Garten
// Intercepts checkout and redirects to N-Genius hosted payment page
(function() {
  var GATEWAY_URL = 'https://dms-mac-mini.tailb1ad03.ts.net';

  function initNGenius() {
    // Intercept "Sicher zur Kasse" button in dobby cart drawer
    var checkoutBtn = document.getElementById('dobby-checkout-btn');
    if (checkoutBtn && !checkoutBtn.dataset.ngeniusHooked) {
      checkoutBtn.dataset.ngeniusHooked = '1';
      checkoutBtn.addEventListener('click', function(e) {
        e.preventDefault();
        handleCheckout();
      });
    }

    // Intercept all /checkout links (cart page, sticky buttons)
    document.querySelectorAll('a[href="/checkout"]').forEach(function(el) {
      if (el.dataset.ngeniusHooked) return;
      el.dataset.ngeniusHooked = '1';
      el.addEventListener('click', function(e) {
        e.preventDefault();
        handleCheckout();
      });
    });

    // Intercept forms posting to /checkout
    document.querySelectorAll('form[action="/checkout"]').forEach(function(form) {
      if (form.dataset.ngeniusHooked) return;
      form.dataset.ngeniusHooked = '1';
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        handleCheckout();
      });
    });
  }

  function handleCheckout() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (!cart.items || cart.item_count === 0) {
          console.log('[N-Genius] Cart is empty, not redirecting');
          return;
        }
        createNGeniusOrder(cart);
      })
      .catch(function(err) {
        console.error('[N-Genius] Cart fetch error:', err);
        window.location.href = '/checkout';
      });
  }

  function createNGeniusOrder(cart) {
    showLoading(true);

    fetch(GATEWAY_URL + '/create-order', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({
        amount: cart.total_price / 100,
        currency: 'EUR',
        shopify_order_id: 'cart_' + Date.now(),
        customer_email: '',
        customer_name: '',
        line_items: cart.items.map(function(i) {
          return {variant_id: i.variant_id, quantity: i.quantity};
        })
      })
    })
    .then(function(r) {
      if (!r.ok) throw new Error('Gateway error: ' + r.status);
      return r.json();
    })
    .then(function(data) {
      showLoading(false);
      if (data.payment_url) {
        window.location.href = data.payment_url;
      } else {
        console.error('[N-Genius] No payment URL:', data);
        window.location.href = '/checkout';
      }
    })
    .catch(function(err) {
      console.error('[N-Genius] Order error:', err);
      showLoading(false);
      window.location.href = '/checkout';
    });
  }

  function showLoading(show) {
    var el = document.getElementById('ngenius-loading');
    if (!el && show) {
      el = document.createElement('div');
      el.id = 'ngenius-loading';
      el.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:99999;display:flex;align-items:center;justify-content:center;font-family:Poppins,sans-serif;color:#fff;font-size:18px;font-weight:600;';
      el.innerHTML = '<div style="text-align:center;"><div style="font-size:40px;margin-bottom:16px;">&#128274;</div><div>Weiterleitung zur sicheren Zahlung...</div></div>';
      document.body.appendChild(el);
    } else if (el) {
      el.style.display = show ? 'flex' : 'none';
    }
  }

  // Run on DOM ready and re-run after delays (dynamic content)
  function run() {
    initNGenius();
    setTimeout(initNGenius, 1000);
    setTimeout(initNGenius, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
